export const ORIENTATION_LEFT = 'orientationLeft';
export const ORIENTATION_RIGHT = 'orientationRight';

export const REACTION_SIZE_SMALL = 10;
export const REACTION_SIZE_REGULAR = 14;
export const REACTION_SIZE_LARGE = 20;
export const REACTION_SIZE_XLARGE = 28;

export const PRODUCT_CLASS_NAME = 'product';
export const SUBSTRATE_CLASS_NAME = 'substrate';
